import { cva } from 'class-variance-authority';

export const drawerBackdropClasses = cva('fixed inset-0 z-[var(--z-backdrop)]', {
  variants: {
    hideBackdrop: {
      true: '',
      false: 'bg-black/40'
    }
  }
});

export const drawerContentClasses = cva(
  'bg-white-50 fixed right-0 bottom-0 left-0 z-[var(--z-modal)] flex w-full flex-col items-center justify-center rounded-t-4xl shadow-xl',
  {
    variants: {
      size: {
        content: 'max-h-[94dvh]',
        full: 'mt-8 h-[100dvh] max-h-[calc(100dvh-1rem)]'
      }
    },
    defaultVariants: {
      size: 'content'
    }
  }
);
export const grabberClasses = cva([
  'my-1-5 mx-auto h-1 w-11 cursor-grab touch-none rounded-full bg-gray-300 select-none active:cursor-grabbing'
]);

export const drawerHeaderClasses = cva(['pb-2-5 flex w-full items-start justify-between px-5']);

export const drawerContentWrapperClasses = cva(['w-full flex-1 overflow-y-auto px-4 py-2']);

export const drawerFooterClasses = cva(['flex w-full flex-col p-4']);
